import { TireHotelRehomeStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { type BadgeVariant, NoddiBadge } from 'noddi-ui-web';
import { TIRE_HOTEL_REHOME_STATUS_ICON, TIRE_HOTEL_REHOME_STATUS_LABEL_MAP } from 'noddi-util';

const VARIANT: Record<TireHotelRehomeStatus, BadgeVariant> = {
  [TireHotelRehomeStatus.DRAFT]: 'outline',
  [TireHotelRehomeStatus.PENDING_BUYER]: 'warning',
  [TireHotelRehomeStatus.COMPLETED]: 'success',
  [TireHotelRehomeStatus.REJECTED]: 'destructive',
  [TireHotelRehomeStatus.EXPIRED]: 'destructive',
  [TireHotelRehomeStatus.CANCELLED]: 'outline'
};

export const OwnershipTransferStatusBadge = ({ status }: { status: TireHotelRehomeStatus }) => (
  <NoddiBadge variant={VARIANT[status]}>
    <NoddiIcon name={TIRE_HOTEL_REHOME_STATUS_ICON[status]} size='small' />
    {TIRE_HOTEL_REHOME_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
